import { useLanguage } from '../../../contexts/LanguageContext';
import { LinkedText } from '../../../components/LinkedText';

export default function WhyChooseSection() {
  const { t } = useLanguage();

  const features = [
    {
      icon: 'ri-shield-check-line',
      en_title: 'Licensed & Secure',
      bm_title: 'Berlesen & Selamat',
      en_desc: 'MrCuci operates under strict international gaming regulations with 256-bit SSL encryption. Your data and funds are always fully protected.',
      bm_desc: 'MrCuci beroperasi di bawah peraturan perjudian antarabangsa yang ketat dengan penyulitan SSL 256-bit. Data dan dana anda sentiasa dilindungi sepenuhnya.',
    },
    {
      icon: 'ri-trophy-line',
      en_title: 'Massive Bonuses',
      bm_title: 'Bonus Yang Besar',
      en_desc: 'Enjoy New Member Register Free RM88, Welcome Bonus 50%, Deposit RM200 Free RM200, and Monthly Competition Deposit Ranking RM1088.',
      bm_desc: 'Nikmati Ahli Baharu Daftar Percuma RM88, Bonus Selamat Datang 50%, Deposit RM200 Percuma RM200, dan Pertandingan Bulanan Kedudukan Deposit RM1088.',
    },
    {
      icon: 'ri-smartphone-line',
      en_title: 'Play Anywhere',
      bm_title: 'Main Di Mana Sahaja',
      en_desc: 'Fully optimised for all devices — desktop, tablet, and mobile. Seamless gameplay on any screen size with zero lag and full feature access.',
      bm_desc: 'Dioptimumkan sepenuhnya untuk semua peranti — desktop, tablet, dan mudah alih. Permainan lancar pada mana-mana saiz skrin tanpa lag.',
    },
    {
      icon: 'ri-headphone-line',
      en_title: '24/7 Support',
      bm_title: 'Sokongan Bahasa Melayu 24/7',
      en_desc: 'Our multilingual support team including fluent Malay speakers is available 24/7 via live chat, email, and phone. Fast, friendly, and professional.',
      bm_desc: 'Pasukan sokongan pelbagai bahasa kami termasuk penutur Bahasa Melayu yang fasih tersedia 24/7 melalui sembang langsung, e-mel, dan telefon.',
    },
    {
      icon: 'ri-bank-card-line',
      en_title: 'Instant Withdrawals',
      bm_title: 'Pengeluaran Segera',
      en_desc: 'Cash out your winnings within minutes. Wide range of Malaysian payment methods with no hidden fees and transparent processing times.',
      bm_desc: 'Keluarkan kemenangan anda dalam beberapa minit. Pelbagai kaedah pembayaran Malaysia tanpa yuran tersembunyi dan masa pemprosesan yang telus.',
    },
    {
      icon: 'ri-vip-crown-line',
      en_title: 'Exclusive VIP Program',
      bm_title: 'Program VIP Eksklusif',
      en_desc: 'Rise through VIP tiers to unlock bigger bonuses, personal account managers, priority withdrawals, luxury gifts, and high-stakes exclusive events.',
      bm_desc: 'Naik melalui tahap VIP untuk membuka kunci bonus yang lebih besar, pengurus akaun peribadi, pengeluaran keutamaan, hadiah mewah, dan acara eksklusif.',
    },
  ];

  return (
    <section
      id="why-choose-ausclub"
      style={{ background: 'linear-gradient(180deg, #080000 0%, #0d0101 100%)' }}
      className="py-16 md:py-24"
    >
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 bg-[#cc1100]/15 border border-[#cc1100]/30 rounded-full px-4 py-1.5 mb-4">
            <span className="w-3 h-3 flex items-center justify-center">
              <i className="ri-star-fill text-[#d4a017] text-xs" />
            </span>
            <span className="text-[#d4a017] text-xs font-semibold tracking-widest uppercase">
              {t('Why We Stand Out', 'Mengapa Kami Terbaik')}
            </span>
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">
            {t('Why Choose', 'Mengapa Pilih')}{' '}
            <span
              className="text-transparent bg-clip-text"
              style={{ backgroundImage: 'linear-gradient(135deg, #cc1100, #d4a017)' }}
            >
              MrCuci?
            </span>
          </h2>
          <p className="text-gray-400 max-w-2xl mx-auto text-sm leading-relaxed">
            <LinkedText>{t(
              'With hundreds of online casinos competing for your attention, MrCuci sets itself apart through fairness, player experience, and genuine rewards for Malaysian players.',
              'Dengan ratusan kasino dalam talian bersaing untuk perhatian anda, MrCuci membezakan dirinya melalui keadilan, pengalaman pemain, dan ganjaran yang tulen untuk pemain Malaysia.'
            )}</LinkedText>
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {features.map((feat, idx) => (
            <div
              key={feat.en_title}
              className="relative border rounded-xl p-5 md:p-6 hover:border-[#d4a017]/40 transition-all duration-300 group overflow-hidden"
              style={{ background: 'linear-gradient(135deg, #180303, #1e0404)', borderColor: 'rgba(204,17,0,0.2)' }}
            >
              <div className="absolute top-0 right-0 w-20 h-20 opacity-5 group-hover:opacity-10 transition-opacity"
                style={{ background: 'radial-gradient(circle at top right, #d4a017, transparent)' }} />

              <div
                className="w-11 h-11 flex items-center justify-center rounded-xl mb-4 group-hover:scale-110 transition-transform"
                style={{ background: 'linear-gradient(135deg, rgba(204,17,0,0.3), rgba(212,160,23,0.2))', border: '1px solid rgba(212,160,23,0.2)' }}
              >
                <i className={`${feat.icon} text-[#d4a017] text-2xl`} />
              </div>
              <div
                className="absolute top-5 right-5 w-6 h-6 flex items-center justify-center rounded-full text-xs font-black"
                style={{ background: 'linear-gradient(135deg, #cc1100, #d4a017)', color: 'black' }}
              >
                {idx + 1}
              </div>
              <h3 className="text-white font-bold text-sm md:text-base mb-2">{t(feat.en_title, feat.bm_title)}</h3>
              <p className="text-gray-500 text-xs md:text-sm leading-relaxed"><LinkedText>{t(feat.en_desc, feat.bm_desc)}</LinkedText></p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
